
const Q = require('q');

const {
	ModalsStack,
	Modal,
} = require('./modals');


const modalsStack = new ModalsStack;

const depricatedPromise = (message) => {
	const p = Q();
	const then = p.then;
	p.then = function (...args) {
		console.warn(message);
		return then.apply(this, args);
	};
	return p;
};


module.exports = {
	_modalsStack: modalsStack,

	ready: function () {
		return modalsStack.ready();
	},

	create: function (options) {
		return new Modal(options);
	},

	show: function (modalOrOptions) {
		let modal;

		if (modalOrOptions instanceof Modal) {
			modal = modalOrOptions;
		} else {
			const options = modalOrOptions;
			modal = this.create(options);
		}

		modalsStack.unshiftOrBringUp(modal);

		return depricatedPromise(
			'`modals.show()` return promise is depricated,'
				+ ' the method is now synchronous'
		);
	},

	hide: function (modal) {
		modalsStack.remove(modal);

		return depricatedPromise(
			'`modals.hide()` return promise is depricated,'
				+ ' the method is now synchronous'
		);
	},

	// create, show and resolve when modal is removed from stack
	showOnce: function (options) {
		const modal = this.create(options);
		this.show(modal);
		return Q.promise(function (resolve) {
			modal.once('deleted', resolve);
		});
	},
};
